import type {
  TypeLibraryCategorySkeleton,
  TypeSessionSkeleton,
} from '../types/generated/contentful'
import type { ContentLibraryCategory, ContentSession } from './contentful-types'
import { contentfulClient } from './contentful-client'
import {
  mapContentLibraryCategory,
  mapContentSession,
} from './contentful-mappers'
import {
  contentLibraryCategorySchema,
  contentSessionSchema,
} from './contentful-types'

export async function fetchContentLibraryCategory(
  locale: string,
): Promise<ContentLibraryCategory> {
  const response =
    await contentfulClient.getEntries<TypeLibraryCategorySkeleton>({
      content_type: 'libraryCategory',
      include: 10,
      locale,
    })

  const [libraryCategory, ...rest] = response.items

  if (rest.length > 0) {
    throw new Error('Multiple library category entries found')
  }

  if (libraryCategory == null) {
    throw new Error('No library category entry found')
  }

  return contentLibraryCategorySchema.parse(
    mapContentLibraryCategory(libraryCategory),
  )
}

export async function fetchContentSession(
  id: string,
  locale: string,
): Promise<ContentSession> {
  const session = await contentfulClient.getEntry<TypeSessionSkeleton>(id, {
    include: 10,
    locale,
  })

  return contentSessionSchema.parse(mapContentSession(session))
}

export type {
  ContentAsset,
  ContentLibraryCategory,
  ContentSession,
} from './contentful-types'
